import posthog from "posthog-js";
import { Component, ErrorInfo, ReactNode } from "react";
import QueryError from "../QueryError/QueryError";

interface Props {
  fallback?: ReactNode;
  /**
   * User-facing text shown when the children fail. Thrown error messages are
   * never rendered, so internal ones (e.g. NetworkError) can't leak into the UI.
   */
  message?: string;
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    posthog.captureException(error, {
      componentStack: info.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      const { fallback, message } = this.props;
      // You can render any custom fallback UI
      return fallback ?? <QueryError type="other" title={message} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
